export const MAX_TABS_LIMIT = 10;
export const MAX_SECTIONS_LIMIT = 50;
export const MAX_SUBSECTIONS_LIMIT = 25;
export const MAX_FIELDS_LIMIT = 6;
export const MAX_TABLE_COLUMNS_LIMIT = 8;
export const MAX_FROZEN_COLUMNS_LIMIT = 3;
export const MAX_WIDTH_PCT = 100;
export const WIDTH_DECIMAL_FACTOR = 100;
